import * as React from 'react';
import { BetslipActualScore } from './EventScore.style';
import { observer } from 'src/utils/mobx-react';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropsType {
    eventId: EventId;
}

export const EventScore = observer('EventScore', ({ eventId }: PropsType): JSX.Element | null => {
    const event = eventId.getEventModel();
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    if (event !== null) {
        const scoreHome = event.scoreHome;
        const scoreAway = event.scoreAway;

        if (scoreHome !== null && scoreAway !== null && event.sport !== 'tennis') {
            return (
                <BetslipActualScore variant={configState.componentVariants.betslipVariant}>
                    {scoreHome}-{scoreAway}
                </BetslipActualScore>
            );
        }
    }

    return null;
});
